import React from 'react';

const Projects = () => {
  return (
    <div className="container-xxl py-5" id="project">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">Projects</h6>
          <h1 className="mb-5">Our latest projects</h1>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="course-item bg-light">
              <div className="position-relative overflow-hidden">
                <img className="img-fluid" src="../assetsTemplates/template1/img/course-1.jpg" alt="" />
                <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3 border-end" style={{ borderRadius: '30px 0 0 30px' }}>Read More</a>
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3" style={{ borderRadius: '0 30px 30px 0' }}>Join Now</a>
                </div>
              </div>
              <div className="text-center p-4 pb-0">
                <h5 className="mb-4">Project tracking</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="course-item bg-light">
              <div className="position-relative overflow-hidden">
                <img className="img-fluid" src="../assetsTemplates/template1/img/course-2.jpg" alt="" />
                <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3 border-end" style={{ borderRadius: '30px 0 0 30px' }}>Read More</a>
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3" style={{ borderRadius: '0 30px 30px 0' }}>Join Now</a>
                </div>
              </div>
              <div className="text-center p-4 pb-0">
                <h5 className="mb-4">TUNEPS</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="course-item bg-light">
              <div className="position-relative overflow-hidden">
                <img className="img-fluid" src="../assetsTemplates/template1/img/course-3.jpg" alt="" />
                <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3 border-end" style={{ borderRadius: '30px 0 0 30px' }}>Read More</a>
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3" style={{ borderRadius: '0 30px 30px 0' }}>Join Now</a>
                </div>
              </div>
              <div className="text-center p-4 pb-0">
                <h5 className="mb-4">Intranet for administration</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="course-item bg-light">
              <div className="position-relative overflow-hidden">
                <img className="img-fluid" src="../assetsTemplates/template1/img/course-4.jpg" alt="" />
                <div className="w-100 d-flex justify-content-center position-absolute bottom-0 start-0 mb-4">
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3 border-end" style={{ borderRadius: '30px 0 0 30px' }}>Read More</a>
                  <a href="#" className="flex-shrink-0 btn btn-sm btn-primary px-3" style={{ borderRadius: '0 30px 30px 0' }}>Join Now</a>
                </div>
              </div>
              <div className="text-center p-4 pb-0">
                <h5 className="mb-4">Interoperability solution</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
